import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Image } from "react-bootstrap";

interface Props {
  id: string;
  isLoading: boolean;
  title: string;
  imgSrc: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BlockEditBoxImage = ({
  id,
  isLoading,
  title,
  imgSrc,
  onChange
}: Props) => {
  const { t } = useTranslation();
  return (
    <Form.Group className="border rounded m-1 p-1">
      <Form.Group className="d-flex justify-content-between align-items-center">
        <Form.Label>
          <p>{title}</p>
          {isLoading && <div>로딩중...</div>}
        </Form.Label>
        <Form.Control
          id={`${id}${title}`}
          type="file"
          style={{display: "none"}}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
        />
        <Form.Label htmlFor={`${id}${title}`}>
          <Button size="sm" variant="outline-secondary" as="span">{t("change")}</Button>
        </Form.Label>
      </Form.Group>
      <a href={imgSrc} target="_blank">
        {!isLoading && (
          <Image
            width={150}
            height={150}
            style={{objectFit: "contain"}}
            src={imgSrc}/>
        )}
      </a>
    </Form.Group>
  )
}

export default BlockEditBoxImage;